import { Pipe, PipeTransform } from '@angular/core';

/**
 * Renders an elapsed duration relative to now, e.g. "Just now", "1 Minute",
 * "7 Days", "1 Month". Unlike CustomTimeAgoPipe it drops the "ago" suffix,
 * title-cases the unit, and rolls weeks into days (so 7 days shows "7 Days").
 */
@Pipe({
  name: 'relativeDuration',
  pure: true,
})
export class RelativeDurationPipe implements PipeTransform {
  private readonly intervals: { unit: string; seconds: number }[] = [
    { unit: 'Year', seconds: 31536000 },
    { unit: 'Month', seconds: 2592000 },
    { unit: 'Day', seconds: 86400 },
    { unit: 'Hour', seconds: 3600 },
    { unit: 'Minute', seconds: 60 },
  ];

  transform(value: any): string {
    if (!value) return '';

    const then = +new Date(value);
    if (isNaN(then)) return '';

    const seconds = Math.floor((+new Date() - then) / 1000);
    if (seconds < 60) return 'Just now';

    for (const { unit, seconds: step } of this.intervals) {
      const counter = Math.floor(seconds / step);
      if (counter > 0) {
        return counter === 1 ? `1 ${unit}` : `${counter} ${unit}s`;
      }
    }

    return 'Just now';
  }
}
